module.exports = "/_next/static/images/a86ff87db7be4db09d15da519d53cc95-open-graph-large.jpg";